<template>
  <form-item-label label="生まれた年" :required="true" />
  <complemented-text-form
    v-if="complementedTextOpened"
    :text="complementedText"
    @open="openForm"
    :editable="true"
    :colspan="1"
  />
  <td v-if="!complementedTextOpened">
    <div
      class="m3p-contact__birthyear"
      :class="shouldDisplayError ? [`m3p-form__errorbox`] : null"
    >
      <selector-field
        class="m3p-select m3p-form__strong"
        :name="fieldName"
        :id="fieldName"
        :options="ageMaster"
        :validator="validator"
        :dispatcher="dispatcher"
      >
        <template #select="props">
          <option :value="null" disabled>生まれた年</option>
          <option
            v-for="item in props.options"
            :value="item.value"
            :key="item.value"
            >{{ item.text }}</option
          >
        </template>
      </selector-field>
      <error-message :name="fieldName" />
    </div>
  </td>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useFieldError } from 'vee-validate';
import ComplementedTextForm from '@component_path/pages/pc/positions/show/common_components/form_element/ComplementedText';
import FormItemLabel from '@component_path/pages/pc/positions/show/common_components/form_element/FormItemLabel';
import ErrorMessage from '@component_path/pages/pc/positions/show/common_components/form_element/ErrorMessage';
import SelectorField from '@component_path/pages/common/form/element/select';
import { useAgeField } from '@component_path/inquiry_form_common_module/custom_hook/Age';

const store = useStore();

const props = defineProps({
  ageMaster: {
    type: Array,
    required: true
  }
});

const { validator, fieldName } = useAgeField(true);
const dispatcher = ref('positionInquiryMail/setAge');
const shouldDisplayError = useFieldError(fieldName.value);

const complementedTextOpened = ref(false);

const age = computed(() => store.state.positionInquiryMail.formData.age);
const complementedText = computed(() => {
  const selectedAge = props.ageMaster.find(item => item.value === age.value);
  return selectedAge ? selectedAge.text : '';
});
const openForm = () => (complementedTextOpened.value = false);

onMounted(() => {
  if (!!age.value) {
    complementedTextOpened.value = true;
  }
});
</script>
